import { Props } from './types';
import * as Styled from './styled';
import { useField } from 'formik';
import Row from '~components/dumbs/Row';

function Checkbox({ label, className, markWhenClickOnLabel, ...props }: Props) {
  const [field] = useField(props);

  return (
    <Row className={className}>
      <Styled.Wrapper>
        <Styled.Checkbox {...props} {...field} />
        <Styled.Checkmark />
        {markWhenClickOnLabel && label}
      </Styled.Wrapper>
      {!markWhenClickOnLabel && label}
    </Row>
  );
}

Checkbox.defaultProps = {
  disabled: false,
  markWhenClickOnLabel: true,
  type: 'checkbox',
};

export default Checkbox;
